// extracted by mini-css-extract-plugin
export default {"outerCircle":"DecoratorCircle_outerCircle__JC8Y3"};